import React from 'react';
import { Row, Col } from 'antd';
import { Field } from 'react-final-form';

import InputSearch from '../formComponents/InputSearch';

const BaseFilter = ({ searchFieldName, children, searchFieldPlaceholder, action, namePath, span = 8, smallPath, component, allowClear, options, isMulti, useReactWindow }) => (
    <Row key='header'>
        <Col span={24}>
            <Row gutter={5}>
                <Col span={span}>
                    <Field
                        action={action}
                        name={searchFieldName}
                        namePath={namePath}
                        smallPath={smallPath}
                        placeholder={searchFieldPlaceholder}
                        component={component || InputSearch}
                        allowClear={allowClear}
                        options={options}
                        isMulti={isMulti}
                        useReactWindow={useReactWindow}
                    />
                </Col>
                { children || null }
            </Row>
        </Col>
    </Row>
);

export default BaseFilter;
